import React from "react";
import PropTypes from "prop-types";
import useConferenceLogs from "../hooks/use-conference-logs";
import { Title } from "../components";
import { LogContainer, LogItem } from "../components/Logs";
import { translate } from "@td/shared_utils";

const Logs = React.memo(({ consultationId, forceAudioConference }) => {
  const logs = useConferenceLogs({ consultationId, forceAudioConference });

  return (
    <React.Fragment>
      <Title>
        {translate(null, "call_details", "call_history")}
      </Title>

      <LogContainer>
        {logs.map(({ id, ...log }) => <LogItem key={id} {...log} />)}
      </LogContainer>
    </React.Fragment>
  );
});

Logs.displayName = "Logs";

Logs.propTypes = {
  consultationId: PropTypes.number.isRequired,
  forceAudioConference: PropTypes.bool
};

export default Logs;
